import Rest from '../rest'
import axios  from 'axios'

/******************************************************************************
 *  Teams
 *****************************************************************************/

/**
 * @type {Team}
 */
export default class Team extends Rest {

    prefix = "https://5e469c01fd1af600145de3cf.mockapi.io/api/v1/dashboard/"

    constructor () {
        super('/teams')
    }

    /**
     * Busca todos os gerentes vinculados a uma equipe
     * 
     * @param {Integer|String} teamId Identificador da equipe
     */
    getManagersByTeam(teamId) {
        return this.http.get(
            this.constructor.normalize('/team', this.constructor.normalize(teamId,'/managers'))
        ).then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)

            return response
        })
    }
    /**
     * Busca todos os supervisor vinculados a uma equipe
     * 
     * @param {Integer|String} teamId Identificador da equipe
     */
    getSupervisorByTeam(teamId) {
        return this.http.get(
            this.constructor.normalize('/team', this.constructor.normalize(teamId,'/supervisors'))
        ).then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)

            return response
        })
    }

    /**
     * Busca todos os corretores vinculados a um gerente
     * 
     * @param {Integer|String} managerId Identificador do gerente
     */
    getBrokersByManager(managerId) {
        return this.getAll(
            this.constructor.normalize('/manager', this.constructor.normalize(managerId,'/brokers/1'))
        ).then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)

            return response
        })
    }

    read() {
        return axios.get(this.prefix + 'team');
    }

    readFilters() {
        return axios.get(this.prefix + 'customers-filters');
    }
}